import { Routes } from '@angular/router';
import { MainLayout } from './layout/main-layout/main-layout';
import { ContentPool } from './modules/content-mapper/content-pool/content-pool';
import { ContentPoolListing } from './modules/content-mapper/content-pool-listing/content-pool-listing';
import { UserListing } from './modules/user-management/user-listing/user-listing';
import { Login } from './modules/auth/login/login';
import { AuthGuard } from './core/guards/auth-guard-guard';
import { SegmentListing } from './modules/segment/segment-listing/segment-listing';
import { SegmentPermission } from './modules/segment/segment-permission/segment-permission';
import { ContentPoolAssets } from './modules/content-mapper/content-pool-assets/content-pool-assets';

export const routes: Routes = [
    {path:'',redirectTo:'login', pathMatch: 'full'},
    {path:'login',component:Login},
    {
        path: 'content-pool',
        component: MainLayout,
        children:[
            {path:'',component:ContentPoolListing,canActivate:[AuthGuard],data:{permission:10}},
            {path:'create-content-pool',component:ContentPool,canActivate:[AuthGuard],data:{permission:11}},
            {path:'edit-content-pool/:id',component:ContentPool,canActivate:[AuthGuard],data:{permission:11}},
            {path:'content-pool-assets/:id',component:ContentPoolAssets,canActivate:[AuthGuard],data:{permission:11}}
        ]
    },
    {
        path: 'user',
        component: MainLayout,
        children:[
            {path:'user-listing',component:UserListing,canActivate:[AuthGuard],data:{permission:5}}
        ]
    },
    {
        path: 'segment',
        component: MainLayout,
        children:[
            {path:'segment-listing',component:SegmentListing,canActivate:[AuthGuard],data:{permission:13}},
            {path:'segment-permission',component:SegmentPermission,canActivate:[AuthGuard],data:{permission:15}}
        ]
    }
];
